import React from "react";
import Footer from "../../components/Footer/Footer";

function News4() {
  return (
    <section className="flex flex-col absolute h-screen min-h-full w-full">
      <div className="relative">
        <div className="flex w-full h-full z-10 absolute items-center justify-center">
          <div className="mx-auto my-auto">
            <span className="text-3xl font-extrabold font-raleway text-white" id="blog" >Titulo</span>
          </div>
        </div>
        <img src="contact.png" alt="logo" className='z-0 top-0 left-0 w-full' />
      </div>
      <div className='flex flex-col mx-auto my-auto h-sm:hidden'>
        <div className='flex flex-col h-full pt-9' style={{ width: '900px' }}>
          <div style={{ width: '900px' }}>
            <img src="us_news.png" alt="logo" className="w-full h-96" />
          </div>

          <div className='mt-2'>
            <span className=''>Quem participa ou pretende entrar em um consórcio geralmente tem uma dúvida comum: afinal, consórcio afeta meu score de crédito? E mais: o score pode influenciar a minha aprovação ou contemplação no consórcio?</span>
          </div>
          <div className='mt-2'>
            <span className=''>Entender a relação entre consórcio e score de crédito é fundamental para quem quer manter a saúde financeira em dia e aproveitar ao máximo essa forma de investimento.</span>
          </div>
          <div className='mt-2'>
            <span className='text-3xl font-extrabold font-raleway'>O que é o score de crédito?</span>
          </div>
          <div className='mt-2'>
            <span className=''>O score de crédito é uma pontuação atribuída por birôs como Serasa, Boa Vista e SPC, que indica o risco de inadimplência de uma pessoa. Vai de 0 a 1000: quanto maior, melhor é o seu histórico com pagamentos e menor o risco para quem vai te conceder crédito.</span>
          </div>
          <div className='mt-2'>
            <span className=''>É uma referência usada por bancos, financeiras, empresas de varejo e, em alguns casos, por administradoras de consórcio.</span>
          </div>
          <div className='mt-2'>
            <span className='text-3xl font-extrabold font-raleway'>Entrar em um consórcio muda meu score?</span>
          </div>
          <div className='mt-2'>
            <span className=''>A resposta direta: não imediatamente.</span>
          </div>
          <div className='mt-2'>
            <span className=''>Ao contratar uma cota de consórcio, seu score não é afetado automaticamente, porque:</span>
          </div>
          <div className='mt-2'>
            <ul className="list-disc list-inside">
              <li className=' mt-2'>O consórcio não é um empréstimo.</li>
              <li className=' mt-2'>Você não recebe crédito à vista, mas sim uma carta de crédito futura.</li>
              <li className=' mt-2'>Em muitos casos, não há consulta ao score para entrar em um grupo.</li>
            </ul>
          </div>
          <div className='mt-2'>
            <span className=''>Ou seja, participar de um consórcio não derruba nem aumenta seu score de forma direta no ato da adesão. Mas atenção: isso muda dependendo de como você lida com os pagamentos.</span>
          </div>
          <div className='mt-2'>
            <span className='text-3xl font-extrabold font-raleway'>Como o consórcio pode impactar o score a médio e longo prazo</span>
          </div>
          <div className='mt-2'>
            <span className=''>Apesar de não mexer no seu score logo de cara, o consórcio pode influenciar positivamente (ou negativamente) sua pontuação ao longo do tempo:</span>
          </div>
          <div className='mt-2'>
            <span className='font-extrabold font-raleway'>Impacto positivo:</span>
          </div>
          <div className='mt-2'>
            <ul className="list-disc list-inside">
              <li className=' mt-2'>Pagamento em dia das parcelas mostra comprometimento financeiro.</li>
              <li className=' mt-2'>Histórico consistente com a administradora pode ser reportado aos birôs de crédito.</li>
              <li className=' mt-2'>Após a contemplação, se a carta for usada com garantia (como imóveis ou veículos), a administradora pode registrar o compromisso, e você passa a ser avaliado como bom pagador se cumprir com os prazos.</li>
            </ul>
          </div>
          <div className='mt-2'>
            <span className='font-extrabold font-raleway'>Impacto negativo:</span>
          </div>
          <div className='mt-2'>
            <ul className="list-disc list-inside">
              <li className=' mt-2'>Atrasos ou inadimplência das parcelas do consórcio podem sim ser reportados e afetar negativamente seu score.</li>
              <li className=' mt-2'>Em caso de contemplação, o não pagamento do saldo devedor pode pesar tanto quanto um financiamento atrasado.</li>
            </ul>
          </div>
          <div className='mt-2'>
            <span className='text-3xl font-extrabold font-raleway'>O score pode influenciar minha aprovação ou contemplação?</span>
          </div>
          <div className='mt-2'>
            <span className=''>Depende da administradora e da fase do consórcio:</span>
          </div>
          <div className='mt-2'>
            <span className=''>Para aderir a um consórcio, o score raramente é um fator decisivo. Na maioria dos casos, não há análise de crédito para entrar.</span>
          </div>
          <div className='mt-2'>
            <span className=''>Para ser contemplado por lance ou após sorteio, algumas administradoras fazem sim uma análise de crédito antes da liberação da carta. Isso evita o risco de inadimplência após a contemplação.</span>
          </div>
          <div className='mt-2'>
            <span className=''>Ou seja: você pode entrar no consórcio com score baixo, mas se quiser usar a carta de crédito após a contemplação, é possível que precise passar por uma análise de crédito, principalmente em grupos de imóveis ou automóveis.</span>
          </div>
          <div className='mt-2'>
            <span className='text-3xl font-extrabold font-raleway'>Dica prática</span>
          </div>
          <div className='mt-2'>
            <span className=''>Se você está com o score baixo, o consórcio pode ser um bom caminho para construir um histórico positivo, desde que mantenha os pagamentos em dia. E se o seu score já é alto, ótimo: isso pode facilitar o processo de liberação da carta de crédito no futuro.</span>
          </div>
          <div className='mt-2'>
            <span className=''>Consórcio e score de crédito andam mais próximos do que parece. Um pode influenciar o outro com o tempo, seja para o bem ou para o mal. O segredo é simples: disciplina nos pagamentos e planejamento financeiro. Assim, você mantém sua pontuação saudável e aproveita tudo de bom que o consórcio pode oferecer.</span>
          </div>
        </div>
      </div>
      <div className="flex w-full z-0 pt-9">
        <Footer />
      </div>
    </section>
  );
}

export default News4;